'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import l$1 from "../defs/CaretRight.js";
var f = Object.defineProperty, p = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, R = Object.prototype.propertyIsEnumerable;
var a = (e, t, r) => t in e ? f(e, t, { enumerable: true, configurable: true, writable: true, value: r }) : e[t] = r, m = (e, t) => {
  for (var r in t || (t = {}))
    c.call(t, r) && a(e, r, t[r]);
  if (o)
    for (var r of o(t))
      R.call(t, r) && a(e, r, t[r]);
  return e;
}, i = (e, t) => p(e, s(t));
const l = forwardRef((e, t) => /* @__PURE__ */ a__default.createElement(b, i(m({ ref: t }, e), { weights: l$1 })));
l.displayName = "CaretRight";
export {
  l as CaretRight
};
